/* eslint-disable react/forbid-prop-types */
import PropTypes from 'prop-types';

import { fillerMap } from '../../../../../options';
import ControllersGroup from '../../../controllers/ControllersGroup';
import {
  InputLineController,
  ToggleSwitchController,
  RangeController,
  ChoiceBoxController,
} from '../../../controllers/Base';

const GeneralControllers = ({
  handle,
  config,
  data,
  extend,
  setExtend,
  selectedLine = undefined,
  selectedLineMap = undefined,
}) => (
  <>
    <ControllersGroup
      title="Opções Gerais"
      id="general"
      key="general"
      extend={extend}
      setExtend={setExtend}
      sizeIncrease={config?.SortValuesControl === 'Customizado' ? data?.index?.length : 0}
    >
      <ChoiceBoxController
        label="Escala"
        handle={handle}
        kWord="ValueScaleControl"
        configValue={config?.ValueScaleControl}
        options={[
          { label: 'linear', value: 'linear', id: 'linear' },
          { label: 'logarítmica', value: 'symlog', id: 'symlog' },
        ]}
        fullWidth
      />
      <RangeController
        label="Espaço entre as categorias"
        handle={handle}
        kWord="PaddingControl"
        configValue={config?.PaddingControl?.value}
        min={0}
        max={0.9}
        step={0.1}
        precision={1}
        fullWidth
      />
      <RangeController
        label="Margem Superior"
        handle={handle}
        kWord="MarginTop"
        configValue={config?.Margin?.top}
        min={0}
        max={500}
        step={1}
        precision={0}
        fullWidth
      />
      <RangeController
        label="Margem Inferior"
        handle={handle}
        kWord="MarginBottom"
        configValue={config?.Margin?.bottom}
        min={0}
        max={500}
        step={1}
        precision={0}
        fullWidth
      />
      <RangeController
        label="Margem Esquerda"
        handle={handle}
        kWord="MarginLeft"
        configValue={config?.Margin?.left}
        min={0}
        max={500}
        step={1}
        precision={0}
        fullWidth
      />
      <RangeController
        label="Margem Direita"
        handle={handle}
        kWord="MarginRight"
        configValue={config?.Margin?.right}
        min={0}
        max={500}
        step={1}
        precision={0}
        fullWidth
      />
      <ToggleSwitchController
        label="Valor mínimo"
        handle={handle}
        kWord="MinValueControl2"
        configValue={config?.MinValueControl?.checked}
        firstOption="Automático"
        secondOption="Manual"
        secondColor="secondary"
      />
      <InputLineController
        isNumber
        precision={2}
        label=""
        handle={handle}
        kWord="MinValue"
        configValue={config?.MinValueControl?.value}
        disabled={config?.MinValueControl?.checked}
      />
      <ToggleSwitchController
        label="Valor máximo"
        handle={handle}
        kWord="MaxValueControl2"
        configValue={config?.MaxValueControl?.checked}
        firstOption="Automático"
        secondOption="Manual"
        secondColor="secondary"
      />
      <InputLineController
        isNumber
        precision={2}
        label=""
        handle={handle}
        kWord="MaxValue"
        configValue={config?.MaxValueControl?.value}
        disabled={config?.MaxValueControl?.checked}
      />
      {selectedLine?.type === 'datetime64[ns]' && selectedLineMap?.value in fillerMap && (
        <ToggleSwitchController
          label="Preencher datas faltantes na linha"
          handle={handle}
          kWord={`ExtendDateLine-${selectedLineMap?.value ?? 'none'}`}
          configValue={config?.ExtendDateLine}
          firstOption=""
          secondOption=""
          fullWidth
        />
      )}
      <ChoiceBoxController
        label="Formato"
        handle={handle}
        kWord="DataAbsoluteFormat"
        configValue={config?.DataAbsoluteFormat}
        options={[
          { label: 'Número', value: 'number', id: 'number' },
          { label: 'Duração', value: 'duration', id: 'duration' },
        ]}
        fullWidth
      />
      {config?.DataAbsoluteFormat === 'duration' && (
        <ChoiceBoxController
          label="Unidade original"
          handle={handle}
          kWord="DurationUnit"
          configValue={config?.DurationUnit}
          options={[
            { label: 'Dias', value: 'days', id: 'days' },
            { label: 'Horas', value: 'hours', id: 'hours' },
            { label: 'Minutos', value: 'minutes', id: 'minutes' },
            { label: 'Segundos', value: 'seconds', id: 'seconds' },
          ]}
          fullWidth
        />
      )}
    </ControllersGroup>
  </>
);

GeneralControllers.propTypes = {
  config: PropTypes.objectOf(PropTypes.any),
  data: PropTypes.objectOf(PropTypes.any),
  handle: PropTypes.func,
  extend: PropTypes.string,
  setExtend: PropTypes.func,
  selectedLine: PropTypes.objectOf(PropTypes.any),
  selectedLineMap: PropTypes.objectOf(PropTypes.any),
};

export default GeneralControllers;
